var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileAttachedPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4039 21.5962L20.5 11.5C23.3995 8.60053 28.1005 8.60053 31 11.5C33.8995 14.3995 33.8995 19.1005 31 22L18.8846 34.1154C16.8773 36.1227 13.6227 36.1227 11.6154 34.1154C9.60805 32.1081 9.60805 28.8535 11.6154 26.8462L23.7308 14.7308C24.846 13.6156 26.654 13.6156 27.7692 14.7308C28.8844 15.846 28.8844 17.6541 27.7692 18.7693L15.25 31.2885",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAttachedPin);
export default __webpack_public_path__ + "static/media/file-attached-pin.78b5c62a6112cc76f3de08949f69fb81.svg";
export { ForwardRef as ReactComponent };